import { render, staticRenderFns } from "./rspToAppealInstructions.vue?vue&type=template&id=7fec1b21"
import script from "./rspToAppealInstructions.vue?vue&type=script&lang=ts"
export * from "./rspToAppealInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports